'use client';

// Third Party
import { c as _c } from "react/compiler-runtime";
import * as React from 'react';

// Utils
import { useMobileSearchModal } from '@components/mobile-search-modal';
import { extractFirstPhraseBeforeComma } from '@utils/extract-first-phrase-before-comma';

// UI
import { Icon, IconNames } from '@components/icon';
type Props = {
  placeName?: string;
};
export const MobileSearchBar: React.FC<Props> = t0 => {
  const $ = _c(8);
  const {
    placeName
  } = t0;
  const {
    activateMobileSearchModal
  } = useMobileSearchModal();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Icon name={IconNames.MAGNIFYING_GLASS} className="h-4 w-4 mt-1 sm:mt-0 text-primary-main" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== placeName) {
    t2 = placeName ? extractFirstPhraseBeforeComma(placeName) : "Where to?";
    $[1] = placeName;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <span className="text-md font-medium text-gray-main" data-testid="@home/search-input-box">{t2}</span>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== activateMobileSearchModal || $[6] !== t3) {
    t4 = <div className="relative top-0 left-0 right-0 py-4 transition-colors duration-500 sm:hidden justify-center items-center text-center"><button onClick={activateMobileSearchModal} className="flex flex-row bg-white p-3 mx-auto rounded-full shadow-lg text-left space-x-2 w-full hover:cursor-pointer mt-1 border-[1.5px] border-primary-main" data-testid="@home/search-input-box-button">{t1}{t3}</button></div>;
    $[5] = activateMobileSearchModal;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};